import classNames from "classnames";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";

type Props = {
  label: JSX.Element | string;
  children: JSX.Element;
  isRequired?: boolean;
  sm?: number;
};
const FormField: React.FC<Props> = (props: Props) => {
  const { label, children, isRequired = false, sm = 3 } = props;

  return (
    <>
      <Row className="align-items-center">
        <Col sm={sm}>
          <Form.Label className={classNames("inline-label", isRequired && "required-field")}>
            {label}
          </Form.Label>
        </Col>
        <Col>{children}</Col>
      </Row>
    </>
  );
};

export default FormField;
